module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#sports",
      toString: function () {
        return this.url;
      }
    }